import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material'
import { grey } from '@mui/material/colors'
import React, { useState } from 'react'

const columns = [
  { name: 'name' },
  { name: 'primary_phone' },
  { name: 'address' },
  { name: 'primary_email' },
  { name: 'fax_number' },
  { name: 'industry' },
  //{name: 'primary_account_owner'},
  { name: 'status' },
  { name: 'lead_source' },
  { name: 'importance' },
  { name: 'product_of_interest' },
  { name: 'type', description: 'individual, business, or partner' },
  { name: 'secondary_phone' },
  { name: 'secondary_email' },
  { name: 'website' },
  { name: 'created_on' },
  { name: 'primary_contact_name' },
  { name: 'primary_contact_phone' },
  { name: 'primary_contact_phone_ext' },
  { name: 'primary_contact_email' },
  { name: 'primary_contact_job_title' },
  { name: 'primary_contact_influence' },
  { name: 'primary_contact_mobile_phone' },
  {
    name: 'secondary_contact_names',
    description:
      'A semicolon ; separated list of secondary contact names. Example: Fred Jones;Mary Smith;Michael Thomas',
  },
  { name: 'notes' },
]

const ImportHelper = () => {
  const [instructionsOpen, setInstructionsOpen] = useState(false)
  return (
    <Box sx={{ mb: 2 }}>
      <Typography>
        If you have a csv file of your current accounts, you can import them
        now. This is a one time process that will require manual intervention to
        correct.
      </Typography>

      <Button onClick={() => setInstructionsOpen(true)}>
        View Instructions
      </Button>

      <Dialog open={instructionsOpen}>
        <DialogTitle>CSV file instructions</DialogTitle>
        <DialogContent>
          <Typography
            sx={{ mb: 1, pb: 1, borderBottom: `1px solid ${grey[500]}` }}
          >
            Here is a list of all of the available columns headers to put in
            your CSV file. For fields like "industry" and "product_of_interest",
            the values in your file must exactly match what you have configured
            in the setup wizard and your company settings.
          </Typography>

          <Box sx={{ maxHeight: '400px', overflow: 'scroll' }}>
            {columns.map((c) => (
              <Typography>
                <b>{c.name}</b>
                {c.description && ': ' + c.description}
              </Typography>
            ))}
          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setInstructionsOpen(false)} variant='outlined'>
            Okay
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}

export default ImportHelper
